import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import Header from './components/common/Header'
import Footer from './components/common/Footer'
import HomeMain from './pages/main/HomeMain'
import CompanyMain from './pages/company/CompanyMain'
import ScooterMain from './pages/scooter/ScooterMain'
import NetworkMain from './pages/network/NetworkMain'
import NetworkGoStation from './pages/network/NetworkGoStation'
import RatePlanMain from './pages/ratePlan/RatePlanMain'
import NewsMain from './pages/news/NewsMain'
import NewsBoardDetail from './pages/news/NewsBoardDetail'
import CustomerServiceNetwork from './pages/customer/CustomerServiceNetwork'
import CustomerCenter from './pages/customer/CustomerCenter'
import CustomerEgcare from './pages/customer/CustomerEgcare'
import CustomerDownload from './pages/customer/CustomerDownload'
import ScooterS2 from './pages/scooter/ScooterS2'
import ScooterPlus from './pages/scooter/ScooterPlus'
import ScooterViva from './pages/scooter/ScooterViva'
import ScooterXl from './pages/scooter/ScooterXl'
import ScooterMix from './pages/scooter/ScooterMix'
import ScooterEvC1 from './pages/scooter/ScooterEvC1'
import ApplicationMain from './pages/application/ApplicationMain'
import SubsidyMain from './pages/subsidy/SubsidyMain'
import AppLinkMain from './pages/applink/AppLinkMain'
import NetworkMapPage from 'pages/network/NetworkMapPage'
import SwapMapPage from 'pages/network/SwapMapPage'
import MapMain from 'pages/map/MapMain'
import CustomerDownloadCenter from 'pages/customer/CustomerDownloadCenter'
import { URL } from './utils/Utils'
import './App.scss'

function App() {
    const location = useLocation()

    return (
        <div className="App">
            {location?.pathname !== URL.APP_LINK &&
                location.pathname !== URL.NETWORK.MAP &&
                location.pathname !== URL.NETWORK.SERVICE_MAP &&
                location.pathname !== URL.MAP.MAIN &&
                location.pathname !== URL.MAP.SERVICE_MAP && <Header />}
            <div id="app">
                <Routes>
                    <Route exact path={URL.HOME.MAIN} element={<HomeMain />} />
                    <Route path={URL.COMPANY.MAIN} element={<CompanyMain />} />
                    <Route path={URL.SCOOTER.MAIN} element={<ScooterMain />} />
                    <Route path={URL.NETWORK.MAIN} element={<NetworkMain />} />
                    {/* 23.05 고객지원 화면 리뉴얼 되면서 해당 파일 close */}
                    {/* <Route path={URL.NETWORK.STATION_LOCATION} element={<NetworkGoStation />} /> */}
                    <Route path={URL.RATE_PLAN.MAIN} element={<RatePlanMain />} />
                    <Route path={URL.NEWS.MAIN} element={<NewsMain />} />
                    <Route path={URL.NEWS.BOARD_DETAIL} element={<NewsBoardDetail />} />
                    <Route path={URL.SCOOTER.S2} element={<ScooterS2 />} />
                    <Route path={URL.SCOOTER.PLUS} element={<ScooterPlus />} />
                    <Route path={URL.SCOOTER.UTILITY} element={<ScooterPlus />} />
                    <Route path={URL.SCOOTER.VIVA} element={<ScooterViva />} />
                    <Route path={URL.SCOOTER.XL} element={<ScooterXl />} />
                    <Route path={URL.SCOOTER.MIX} element={<ScooterMix />} />
                    <Route path={URL.SCOOTER.EV_C1} element={<ScooterEvC1 />} />
                    <Route path={URL.APPLICATION} element={<ApplicationMain />} />
                    {/* 23.12.19 사전구매예약 close, 외부url로 대체(https://evbikemall.co.kr) */}
                    <Route path={URL.SUBSIDY.MAIN} element={<SubsidyMain />} />
                    {/* 23.10.23 시승행사 end */}
                    {/* <Route path={URL.SUBSIDY.DIFA2023} element={<SubsidyMain />} /> */}
                    <Route path={URL.CUSTOMER.CUSTOMER_CENTER} element={<CustomerCenter />}></Route>
                    <Route path={URL.CUSTOMER.EG_CARE} element={<CustomerEgcare />}></Route>
                    {/* 230621 서비스망이 갖춰진 이후 서비스네트워크 메뉴는  수정 후 오픈 예정 */}
                    <Route path={URL.CUSTOMER.SERVICE_NETWORK} element={<CustomerServiceNetwork />}></Route>
                    <Route path={URL.CUSTOMER.DOWNLOAD} element={<CustomerDownload />}></Route>
                    <Route path={URL.CUSTOMER.DOWNLOAD_CENTER} element={<CustomerDownloadCenter />}></Route>
                    <Route path={URL.APP_LINK} element={<AppLinkMain />}></Route>

                    {/* 스왑스테이션 map만 따로 볼 화면 */}
                    <Route path={URL.NETWORK.MAP} element={<SwapMapPage />} />
                    {/* 서비스네트워크 map만 따로 볼 화면 */}
                    <Route path={URL.NETWORK.SERVICE_MAP} element={<NetworkMapPage />} />
                    {/* 모바일사용자가 따로 볼 map 화면 ㅎㅎ */}
                    <Route path={URL.MAP.MAIN} element={<MapMain isNewPage={true} />} />
                    {/* 새창으로 켠 서비스네트워크맵 */}
                    <Route path={URL.MAP.SERVICE_MAP} element={<MapMain isNewPage={true} type="network" />} />
                </Routes>
            </div>
            {location?.pathname !== URL.APP_LINK &&
                location.pathname !== URL.NETWORK.MAP &&
                location.pathname !== URL.NETWORK.SERVICE_MAP &&
                location.pathname !== URL.MAP.MAIN &&
                location.pathname !== URL.MAP.SERVICE_MAP && <Footer />}
        </div>
    )
}

export default App
